import type { ReactElement } from 'react';

import Message from 'components/technical/Message.tsx';

export const NoAssetFoundErrorMessage = (): ReactElement => <Message>Asset not found</Message>;
